import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useSnackbar } from "@/packages/vue3-snackbar";

import { useGlobalStore } from "@/stores/globalStore";
import { LOCALES, switchLanguage } from "@/packages/i18n/translation";
import * as CountryCodeByLocales from "@/assets/data/country_codes_by_locales.json";
import LanguageByLocales from "@/assets/data/language_by_locales.js";

export default () => {
  const globalStore = useGlobalStore();
  const snackbar = useSnackbar();
  const detectedCountryCode = computed(
    () => globalStore.global.detectedGeo?.country_code
  );
  const isDismissed = ref(false);

  const findUserCountryDataByCountryCode = computed(() =>
    CountryCodeByLocales.default.find(
      (country) => country.country === detectedCountryCode.value
    )
  );

  // intersection between two array
  // ie. array1: ["en", "pt", "tr"], array2: ["pt"] = true
  const supportedAppLanguagesByUser = (supportedAppLocales, userGeoLocales) => {
    return userGeoLocales.filter((value) =>
      supportedAppLocales.includes(value.toLowerCase())
    );
  };

  const findLaguageName = () => {
    if (!findUserCountryDataByCountryCode.value) {
      return;
    }

    const supportedFirstLocale =
      findUserCountryDataByCountryCode.value.locales[0];

    const supportedLanguageName =
      LanguageByLocales[supportedFirstLocale.toLowerCase()].name;

    return supportedLanguageName;
  };

  const snackbarText = computed(() => {
    const detectedLanguage = findLaguageName();

    return `Would you like to translate to ${detectedLanguage}? 
		<span class="snackbar-button"><button id="clickYes">Yes</button>`;
  });

  const handleGeolocationSnackbar = () => {
    if (!findUserCountryDataByCountryCode.value) {
      return;
    }

    const userGeoLocaleIsUnSupported =
      !supportedAppLanguagesByUser(
        Object.values(LOCALES).map(({ value }) => value),
        findUserCountryDataByCountryCode.value.locales
      ).length > 0;

    const currentAppLangIsToUserLang =
      findUserCountryDataByCountryCode.value.locales.includes(
        globalStore.language.toLowerCase()
      );

    if (
      userGeoLocaleIsUnSupported ||
      currentAppLangIsToUserLang ||
      isDismissed.value
    ) {
      return;
    }

    snackbar.add({
      type: "info",
      text: snackbarText.value,
      dismissible: true,
      duration: 15000,
    });

    // let it appear to dom
    setTimeout(() => {
      document.getElementById("clickYes").addEventListener("click", () => {
        switchLanguage(findUserCountryDataByCountryCode.value.locales[0]);
        snackbar.clear();
        isDismissed.value = true;
      });
      document
        .querySelector(".vue3-snackbar-message-close")
        .addEventListener("click", () => {
          isDismissed.value = true;
        });
    }, 1000);
  };

  return {
    detectedCountryCode,
    handleGeolocationSnackbar,
  };
};
